import { useEffect, useRef } from 'react';

export default function useErudaHack() {
  const erudaRef = useRef();

  useEffect(() => {
    window.__erudaToDisplayListenElement?.(erudaRef.current);
  }, []);

  return erudaRef;
}
